import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { logout } from 'redux/modules/auth';
import Divider from 'material-ui/Divider';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import { Avatar } from 'components';
import * as styles from './Navbar.scss';
var OrgTabMenu = (_dec = connect(function (state, ownProps) {
  return {
    isLikeableUser: state.config.userType.isLikeableUser,
    selectedOrgTabs: state.organization.selectedOrgTabs,
    user: state.auth.user,
    theme: state.theme
  };
}, {
  logout: logout
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(OrgTabMenu, _Component);

  var _super = _createSuper(OrgTabMenu);

  function OrgTabMenu() {
    _classCallCheck(this, OrgTabMenu);

    return _super.apply(this, arguments);
  }

  _createClass(OrgTabMenu, [{
    key: "render",
    value: function render() {
      var name = this.props.user ? "".concat(this.props.user.firstName, " ").concat(this.props.user.lastName) : '';

      var orgDropdownItems = _toConsumableArray(this.props.overrideOrgs ? this.props.overrideOrgs : this.props.selectedOrgTabs).map(function (org) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: org.id,
          primaryText: org.name,
          onClick: function onClick() {
            return browserHistory.push({
              pathname: "/org/".concat(org.id)
            });
          }
        });
      });

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconMenu, {
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'bottom'
        },
        iconButtonElement: /*#__PURE__*/React.createElement(IconButton, {
          style: {
            padding: 0,
            height: 40,
            width: 56
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.controlButton
        }, /*#__PURE__*/React.createElement("i", {
          className: "icon ion-ios-arrow-down"
        })))
      }, orgDropdownItems));
    }
  }]);

  return OrgTabMenu;
}(Component)) || _class);
export { OrgTabMenu as default };